import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import PageError from '@zenbusiness/zui/PageError';
import Stack from '@zenbusiness/zui/Stack';

import {
  InvoicePaymentsContainer,
  InvoicePaymentsCompanyName,
  InvoicePaymentsSubtitle,
} from '../../InvoicePayments.style';
import InvoicePaymentsHeader from '../InvoicePaymentsHeader';

function InvoicePaymentsLayout({ companyName, titleId, subtitleId, children }) {
  return (
    <ErrorBoundary fallback={<PageError />} id="src/pages/InvoicePayments">
      <InvoicePaymentsHeader />
      <InvoicePaymentsContainer>
        <Stack spacing={3}>
          <Box>
            {companyName && <InvoicePaymentsCompanyName>{companyName}</InvoicePaymentsCompanyName>}
            <Heading component="h1" size="lg" weight="medium">
              <FormattedMessage id={titleId} />
            </Heading>
            {subtitleId && (
              <InvoicePaymentsSubtitle>
                <FormattedMessage id={subtitleId} />
              </InvoicePaymentsSubtitle>
            )}
          </Box>
          {children}
        </Stack>
      </InvoicePaymentsContainer>
    </ErrorBoundary>
  );
}

InvoicePaymentsLayout.propTypes = {
  companyName: PropTypes.string,
  titleId: PropTypes.string.isRequired,
  subtitleId: PropTypes.string,
  children: PropTypes.node,
};

export default InvoicePaymentsLayout;
